<template>
    <div>
        <div class="chart" ref="chartElement"></div>
    </div>
</template>
<script>
    import { GoogleCharts } from 'google-charts';
    export default {
        components: {},
        props: {
            rows: { type: Array, required: true },
            chartType: { type: String, default: 'LineChart' },
            columnSettings: { type: Array, required: true },
            chartOptions: { type: Object, required: true }
        },

        created() {
            this.init();
        },

        computed: {},

        watch: {
            rows: {
                handler: function () {
                    this.init();
                },
                immediate: true
            },
            filter: {
                handler: function () {
                    this.init();
                },
                immediate: true
            }
        },

        methods: {
            async init() {
                const chartFunction = this[`draw${this.chartType}`];
                if (chartFunction) {
                    GoogleCharts.load(chartFunction);
                }
            },

            setChartErrorHandler(chart) {
                GoogleCharts.api.visualization.events.addListener(
                    chart,
                    'error',
                    (e) => {
                        chart.container.innerText = this.$t(
                            'dashboard.statistieken.NoDataAvailable'
                        );
                        chart.container.className = 'errorChart';
                    }
                );
            },

            drawLineChart() {
                const rows = this.rows;
                const data = new GoogleCharts.api.visualization.DataTable();
                this.columnSettings.forEach(({ name, type }) => {
                    data.addColumn(type, name);
                });
                data.addRows(rows);
                const options = this.chartOptions;
                const chart = new GoogleCharts.api.visualization.LineChart(
                    this.$refs.chartElement
                );

                this.setChartErrorHandler(chart);
                chart.draw(data, options);
            },

            drawColumnChart() {
                const rows = this.rows;
                const data = new GoogleCharts.api.visualization.DataTable();
                this.columnSettings.forEach(({ name, type }) => {
                    data.addColumn(type, name);
                });
                data.addRows(rows);
                const options = this.chartOptions;
                const chart = new GoogleCharts.api.visualization.ColumnChart(
                    this.$refs.chartElement
                );

                this.setChartErrorHandler(chart);
                chart.draw(data, options);
            },

            drawBarChart() {
                const rows = this.rows;
                const data = new GoogleCharts.api.visualization.DataTable();
                this.columnSettings.forEach(({ name, type }) => {
                    data.addColumn(type, name);
                });
                data.addRows(rows);
                const options = this.chartOptions;
                const chart = new GoogleCharts.api.visualization.BarChart(
                    this.$refs.chartElement
                );

                this.setChartErrorHandler(chart);
                chart.draw(data, options);
            },

            drawComboChart() {
                const rows = this.rows;
                const data = new GoogleCharts.api.visualization.DataTable();
                this.columnSettings.forEach(({ name, type }) => {
                    data.addColumn(type, name);
                });
                // height added: "Datum" text wasn't complete by at least 12 months
                data.addRows(rows);
                let options = {
                    ...this.chartOptions,
                    chartArea: { left: 90, width: '75%', height: 180 }
                };
                // width depends from number of months: 45, 60, 75%
                let len = this.rows.length;
                if (len < 3) {
                    let width = 75 - (3 - len) * 15;
                    options.chartArea.width = `${width.toString()}%`;
                }
                const chart = new GoogleCharts.api.visualization.ComboChart(
                    this.$refs.chartElement
                );

                this.setChartErrorHandler(chart);
                chart.draw(data, options);
            }
        }
    };
</script>

<style lang="scss" scoped>
.chart {
    height: 300px;
    width: calc(100vw - 35px);
}

.errorChart {
    height: 75px;
    width: 800px;
}
</style>
